import { PayloadAction } from '@reduxjs/toolkit'
import { BigSale, Sale, SaleSliceState } from 'src/core/models'
import { initialState } from './state'

export const reducers = {
  /* My Sales List Reducers */
  setMySalesLoading: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.list.loading = action.payload
  },
  setMySalesList: (state: SaleSliceState, action: PayloadAction<Sale[]>) => {
    state.list.sales = action.payload
  },
  setMySalesError: (state: SaleSliceState, action: PayloadAction<any>) => {
    state.list.error = action.payload
  },
  resetMySalesList: (state: SaleSliceState) => {
    state.list = initialState.list
  },
  setMySalesSelected: (state: SaleSliceState, action: PayloadAction<Sale[]>) => {
    state.list.selected = action.payload
  },
  setMySalesFiltered: (state: SaleSliceState, action: PayloadAction<Sale[]>) => {
    state.list.filtered = action.payload
  },
  setMySalesFilterText: (state: SaleSliceState, action: PayloadAction<string>) => {
    state.list.filterText = action.payload
  },
  /* My Sales Details Reducers */
  setSaleDetailsLoading: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.getOne.loading = action.payload
  },
  setSaleDetailsData: (state: SaleSliceState, action: PayloadAction<BigSale>) => {
    state.getOne.sale = action.payload
  },
  setSaleDetailsError: (state: SaleSliceState, action: PayloadAction<any>) => {
    state.getOne.error = action.payload
  },
  resetSaleDetails: (state: SaleSliceState) => {
    state.getOne = initialState.getOne
  },
  /* Send Documents Reducers */
  setSaleSendDocumentLoading: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.sendDocument.loading = action.payload
  },
  setSaleSendDocumentSuccess: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.sendDocument.success = action.payload
  },
  setSaleSendDocumentError: (state: SaleSliceState, action: PayloadAction<any>) => {
    state.sendDocument.error = action.payload
  },
  resetSaleSendDocuments: (state: SaleSliceState) => {
    state.sendDocument = initialState.sendDocument
  },
  /* Delete Document Documents */
  setSaleDeleteDocumentLoading: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.deleteDocument.loading = action.payload
  },
  setSaleDeleteDocumentSuccess: (state: SaleSliceState, action: PayloadAction<boolean>) => {
    state.deleteDocument.success = action.payload
  },
  setSaleDeleteDocumentError: (state: SaleSliceState, action: PayloadAction<any>) => {
    state.deleteDocument.error = action.payload
  },
  resetSaleDeleteDocuments: (state: SaleSliceState) => {
    state.deleteDocument = initialState.deleteDocument
  }
}
